/*
 * This is the "Settings" button that appears on the video control bar.
 */
import $ from 'jquery';
import _ from 'underscore';
import videojs from 'video.js';

import 'bundles/videojs/plugins/autoplayMenuSection';
import {
  KEY_DOWN_ARROW,
  KEY_ENTER,
  KEY_ESCAPE,
  KEY_SPACE,
  KEY_TAB,
  KEY_UP_ARROW,
} from 'bundles/videojs/plugins/keyboardConstants';
import 'bundles/videojs/plugins/playbackRateMenuSection';
import 'bundles/videojs/plugins/resolutionMenuSection';

import _t from 'i18n!nls/videojs';

const HIGHLIGHT_CLASS = 'vjs-highlighted';

const handleEnterAndSpaceKeys = function (menu) {
  menu.lockShowing();
  const $menuButtons = $(menu.contentEl_).find('button');
  const activeButton = _($menuButtons).find(function (one) {
    return $(one).hasClass(HIGHLIGHT_CLASS);
  });

  if (activeButton) {
    $(activeButton).removeClass(HIGHLIGHT_CLASS);
    $(activeButton).blur();
  } else {
    $menuButtons.eq(0).addClass(HIGHLIGHT_CLASS);
    $menuButtons.eq(0).focus();
  }
};
const handleTabAndEscapeKeys = function (menu) {
  $(menu.contentEl_).find('button').removeClass(HIGHLIGHT_CLASS);
  menu.unlockShowing();
};

const handleUpAndDownArrowKeys = function (menu, direction) {
  menu.lockShowing();
  let activeIndex = -1;
  const $menuButtons = $(menu.contentEl_).find('button');
  const activeButton = _($menuButtons).find(function (one) {
    return $(one).hasClass(HIGHLIGHT_CLASS);
  });

  if (activeButton) {
    activeIndex = _($menuButtons).indexOf(activeButton);
    $(activeButton).removeClass(HIGHLIGHT_CLASS);
    $(activeButton).blur();
  }

  if (activeIndex === 0 && direction === -1) {
    $menuButtons.eq($menuButtons.length - 1).addClass(HIGHLIGHT_CLASS);
    $menuButtons.eq($menuButtons.length - 1).focus();
  } else if (activeIndex < 0 || activeIndex >= $menuButtons.length - 1) {
    $menuButtons.eq(0).addClass(HIGHLIGHT_CLASS);
    $menuButtons.eq(0).focus();
  } else {
    $menuButtons.eq(activeIndex + direction).addClass(HIGHLIGHT_CLASS);
    $menuButtons.eq(activeIndex + direction).focus();
  }
};

class SettingsMenuButton extends videojs.getComponent('MenuButton') {
  constructor(player, options = {}) {
    super(player, options);
    const label = _t('Settings');
    this.menuButton_.el_.innerHTML = '<span class="cif-2x cif-fw cif-cog"></span>';
    this.menuButton_.el_.innerHTML += `<span class="vjs-control-text">${label}</span>`;
    this.menuButton_.el_.setAttribute('aria-label', label);
    this.menuButton_.addClass('vjs-control');
    this.menuButton_.addClass('c-vjs-button');
  }

  createEl() {
    const el = super.createEl();
    const $el = $(el);
    $el.attr('data-js', 'settings-menu-button');
    $el.addClass('c-video-control c-settings-control vjs-menu-button-popup');
    return el;
  }

  handleKeyPress(e) {
    const $button = $(this.player_.controlBar.settingsMenuButton.contentEl_);

    const {
      settingsMenuButton: { menu },
    } = this.player_.controlBar;

    if (e.keyCode === KEY_UP_ARROW || e.keyCode === KEY_DOWN_ARROW) {
      handleUpAndDownArrowKeys(menu, e.keyCode === KEY_UP_ARROW ? -1 : 1);
      $button.focus();
      e.preventDefault();
      e.stopPropagation();
    } else if (e.keyCode === KEY_TAB || e.keyCode === KEY_ESCAPE || (e.shiftKey && e.keyCode === KEY_TAB)) {
      handleTabAndEscapeKeys(menu);
      $button.blur();
    } else if (e.keyCode === KEY_ENTER || e.keyCode === KEY_SPACE) {
      handleEnterAndSpaceKeys(menu);
      $button.focus();
      e.preventDefault();
      e.stopPropagation();
    }
  }

  createMenu() {
    const Menu = videojs.getComponent('Menu');
    const menu = new Menu(this.player_, {
      contentElType: 'div',
    });

    _.each(
      this.createItems(),
      function (item) {
        menu.addItem(item);
      },
      this
    );

    return menu;
  }

  createItems() {
    const ResolutionMenuSection = videojs.getComponent('ResolutionMenuSection');
    const items = [new ResolutionMenuSection(this.player_, {})];

    const PlaybackRateMenuSection = videojs.getComponent('PlaybackRateMenuSection');
    items.push(new PlaybackRateMenuSection(this.player_, {}));

    const AutoplayMenuSection = videojs.getComponent('AutoplayMenuSection');
    items.push(new AutoplayMenuSection(this.player_, {}));
    return items;
  }
}

videojs.registerComponent('SettingsMenuButton', SettingsMenuButton);
